import { GraphQLClient } from "graphql-request";

import config from "@app/config";

export const shopify = async (query, variables?: any) => {
  if (!window.Shopify.shop) return null;

  const graphQLClient = new GraphQLClient(
    `https://${
      config.stores[window.Shopify.shop.replace(".myshopify.com", "")].shopify_domain
    }.myshopify.com/api/2023-07/graphql`,
    {
      headers: {
        "X-Shopify-Storefront-Access-Token":
          config.stores[window.Shopify.shop.replace(".myshopify.com", "")].storefront_access_token,
      },
    }
  );
  return await graphQLClient.request(query, variables);
};
